import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { FormField } from '../../../components/FormFields';
import { Check, ChevronRight, Left } from '../../../components/Icon';
import { Input } from '../../../components/Input';
import { Loader } from '../../../components/Loader';
import { PageHeader } from '../../../components/PageHeader';
import { selectWorks } from '../../Api/selectors';
import { applyKanbanFilters, refreshBoards, setActiveBoard } from '../actions';
import { KanbanFilter } from '../components/KanbanFilter';
import { FiltersCloud } from '../components/KanbanFilterCloud';
import {
  BUYERS_OPTIONS,
  COMPANY_LOCATION_OPTIONS,
  PLANNABLE_STATUS_OPTIONS,
  REQUEST_KANBAN_BOARD,
  REQUEST_KANBAN_BOARD_PERFORM_ACTION,
  VEHICLE_STATUS_OPTIONS,
} from '../constants';
import { selectActiveKanbanColumns, selectKanbanBoard, selectKanbanFilter } from '../selectors';
import { KanbanBoard } from './board';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';
import { ButtonBar } from '../../../components/ButtonBar';
import _ from 'lodash';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import styles from './details.module.css';
import { KanbanBoardMobile } from './boardMobile';
import { SearchLocationCompanyId } from '../components/SearchLocationCompanyId';

const Container = styled.div`
  .content {
    display: inline-block;
  }

  .filters {
    cursor: ${props => (props.disabledFilters ? 'not-allowed' : '')};
    opacity: ${props => (props.disabledFilters ? '0.5' : '')};

    background-color: white;
    padding: 22px;
    margin-bottom: 22px;
  }
  .filters-row {
    padding: 10px 0 0;
  }
`;

const STATE = {
  search: '',
  hideEmptyColumns: false,
};

/* eslint-disable react/prefer-stateless-function */
class KanbanBoardDetailsComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
    this._filterRef = { search: '' };
  }

  componentDidMount() {
    this.props.fetch();
  }

  get board() {
    return this.props.board;
  }

  get filterObject() {
    return this._filterRef;
  }

  get isCompanyBoard() {
    return this.board?.columns[0]?.actions[0]?.entity?.name === 'company';
  }

  get isInspectieColumn() {
    const inspectieColumn = this.board?.columns?.filter(col => col?.actions[0]?.functionName == 'WS2_1_Interior');
    return inspectieColumn?.length;
  }

  onSearchChange(evt) {
    const search = evt.target.value;
    this.setState({ search: search });
    this._filterRef.search = search;
  }

  render() {
    if (this.props.work && !this.isInspectieColumn) return <Loader small />;

    if (!this.board) {
      return 'x';
    }

    return (
      <Container disabledFilters={this.isCompanyBoard}>
        <PageHeader
          title={
            <div onClick={this.tofn('/boards')}>
              <Left />
              {this.lbl('kanban.overview.title')}
            </div>
          }
          breadCrumbs={
            <>
              <a href="/">Vindat</a>
              <ChevronRight />
              {this.lbl('kanban.overview.title')}
              <ChevronRight />
              {this.board.label}
            </>
          }
        />

        <div className="filters">
          <form>
            <div className="col-lg-6">
              <input
                className="form-control"
                disabled={this.isCompanyBoard}
                name="search"
                value={this.state.search}
                placeholder="Search..."
                onChange={this.onSearchChange.bind(this)}
              />
            </div>

            {/* commented because not working */}

            {/* <ButtonBar className="mt-2">
              {_.times(4, n => (
                <Button
                  primary={n == this.state.plannable_status}
                  key={`plannable_${n}`}
                  onClick={this.setStateFn({ plannable_status: n })}
                >
                  {this.lbl(`vehicle.plannable.status.${n}`)}
                </Button>
              ))}
            </ButtonBar>


            {/* commented because not working */}

            <div className="row mt-2 mb-2" style={this.isCompanyBoard ? { pointerEvents: 'none' } : {}}>
              <div className="col-12 col-sm-6 col-md-6 col-lg-3">
                <KanbanFilter name="creditor_company" type="single" search="company" />
              </div>
              <div className="col-12 col-sm-6 col-md-6 col-lg-3">
                <KanbanFilter name="invoice_outgoing_company_id" type="single" search="company" />
              </div>
              <div className="col-12 col-sm-6 col-md-6 col-lg-3">
                <KanbanFilter name="user_seller_id" type="single" search="user" options={BUYERS_OPTIONS} />
              </div>
              <div className="col-12 col-sm-6 col-md-6 col-lg-3">
                <KanbanFilter name="user_buyer_id" type="single" search="user" options={BUYERS_OPTIONS} />
              </div>

              {env.clientId === AppClientId.HOOIKAMMER && (
                <KanbanFilter name="HOOI_uitslag_done_date" type="ranged_date" search="vehicle" />
              )}
            </div>
            <div className="row mt-2 mb-2" style={this.isCompanyBoard ? { pointerEvents: 'none' } : {}}>
              <div className="col-12 col-sm-6 col-md-6 col-lg-3">
                <KanbanFilter name="status" type="multiple" search="user" options={VEHICLE_STATUS_OPTIONS} />
              </div>

              <div className="col-12 col-sm-6 col-md-6 col-lg-3">
                <KanbanFilter
                  name="task_name"
                  type="multiple"
                  search="user"
                  label={this.lbl('vehicle.filter.task_name')}
                  options={PLANNABLE_STATUS_OPTIONS}
                />
              </div>

              <div className="col-12 col-sm-6 col-md-6 col-lg-3 d-flex align-items-end">
                <SearchLocationCompanyId filter={this.props.filter} />
              </div>
            </div>

            <div className="mt-2 d-flex gap-2">
              <ButtonComponent
                style={'ButtonSoftEdit'}
                disabled={this.isCompanyBoard}
                onClick={() => this.props.applyFilters()}
              >
                {this.lbl('vehicle.filter.apply')}
              </ButtonComponent>
              <ButtonComponent
                style={'ButtonSoftPrimary'}
                onClick={this.setStateFn({ hideEmptyColumns: !this.state.hideEmptyColumns })}
              >
                {this.state.hideEmptyColumns ? <Check /> : null} Hide empty
              </ButtonComponent>
            </div>
            <FiltersCloud />
          </form>
        </div>

        {window.innerWidth <= 768 ? (
          <KanbanBoardMobile
            board={this.board}
            onChange={this.props.fetch}
            hideEmptyColumns={this.state.hideEmptyColumns}
            filter={this.filterObject}
          />
        ) : (
          <div className={styles.containerKanbanBoard}>
            <KanbanBoard
              board={this.board}
              onChange={this.props.fetch}
              filter={this.filterObject}
              hideEmptyColumns={this.state.hideEmptyColumns}
            />
          </div>
        )}
      </Container>
    );
  }
}

KanbanBoardDetailsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    board: selectKanbanBoard(ownProps.board_id),
    cols: selectActiveKanbanColumns(),
    work: selectWorks([REQUEST_KANBAN_BOARD, REQUEST_KANBAN_BOARD_PERFORM_ACTION]),
    filter: selectKanbanFilter(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      dispatch(setActiveBoard(parseInt(ownProps.board_id, 10)));
      dispatch(refreshBoards());
    },
    applyFilters() {
      dispatch(applyKanbanFilters());
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const KanbanBoardDetails = compose(withConnect, withRouter)(KanbanBoardDetailsComp);
